import { render, staticRenderFns } from "./BuyDialog.vue?vue&type=template&id=c8b3ad70&scoped=true"
import script from "./BuyDialog.vue?vue&type=script&lang=js"
export * from "./BuyDialog.vue?vue&type=script&lang=js"
import style0 from "./BuyDialog.vue?vue&type=style&index=0&id=c8b3ad70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b3ad70",
  null
  
)

export default component.exports